import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  IExtendableDto,
  RydeUiUnit,
  sessionStorageHelpers,
  starredDisplayModeAtomFamily,
  StarredDisplayModeEnum,
  starredTableRowsIdsAtomFamily,
} from "@ryde/shared";

export const useStarredRows = (entity: RydeUiUnit) => {
  const setStarredRows = useSetRecoilState(
    starredTableRowsIdsAtomFamily(entity),
  );
  const setStarredDisplayMode = useSetRecoilState(
    starredDisplayModeAtomFamily(entity),
  );

  const cleanupStarred = useEvent((): void => {
    setStarredRows([]);
    sessionStorageHelpers.setItem(`starred_ids_${entity}`, []);
    setStarredDisplayMode(StarredDisplayModeEnum.ShowAllIncludeStarred);
  });

  const synchroStarredWithRows = useEvent(
    (rows: IExtendableDto[] | undefined): void => {
      if (!rows?.length) {
        cleanupStarred();
        return;
      }

      const validIds = new Set(rows.map(r => r.id));
      setStarredRows(prev => {
        const starredUpdated = prev.filter(id => validIds.has(id));
        sessionStorageHelpers.setItem(`starred_ids_${entity}`, starredUpdated);
        return starredUpdated;
      });
    },
  );

  const removeStarredIds = useEvent((ids: number[]): void => {
    if (!ids?.length) {
      return;
    }

    const idsSet = new Set(ids);
    setStarredRows(prev => {
      const starredUpdated = prev.filter(starredId => !idsSet.has(starredId));

      if (starredUpdated.length === prev.length) {
        return prev;
      }

      sessionStorageHelpers.setItem(`starred_ids_${entity}`, starredUpdated);
      return starredUpdated;
    });
  });

  return { synchroStarredWithRows, removeStarredIds, cleanupStarred };
};
